export default __webpack_public_path__ + "static/media/Flag_of_Iran.f6980301.svg";